import {
  getMimicQualityTier,
  getRenderCostBudgetMs,
} from './mimicQualityController'

// Mimic debug overlay: hardcode the default to true (or set
// `window.mimicDebug = true` in the console) to draw each mimic's buffer
// resolution, quality tier and last fan-out render time on top of the mimics
const MIMIC_DEBUG_DEFAULT = false

const isMimicDebugEnabled = () =>
  (window as { mimicDebug?: boolean }).mimicDebug ?? MIMIC_DEBUG_DEFAULT

const drawMimicDebugOverlay = (c: HTMLCanvasElement, renderCost: number) => {
  const ctx = c.getContext('2d')
  if (!ctx) return
  const tier = getMimicQualityTier()
  const budget = getRenderCostBudgetMs()
  const color =
    renderCost > budget ? 'red' : renderCost > budget / 2 ? 'orange' : 'lime'
  const lines = [
    `${c.width}x${c.height}`,
    `${tier.height}p@${tier.fps}`,
    `${renderCost.toFixed(1)}ms/${budget.toString().replace(/^0\./, '.')}`,
  ]
  ctx.save()
  // The buffer is sized in device pixels — scale so the overlay keeps a
  // constant on-screen size
  const dpr = window.devicePixelRatio || 1
  ctx.scale(dpr, dpr)
  ctx.font = '9px monospace'
  ctx.textBaseline = 'top'
  ctx.fillStyle = 'rgba(0, 0, 0, 0.6)'
  ctx.fillRect(0, 0, 50, lines.length * 10 + 4)
  ctx.fillStyle = color
  lines.forEach((line, index) => ctx.fillText(line, 2, 2 + index * 10))
  ctx.restore()
}

export { isMimicDebugEnabled, drawMimicDebugOverlay }
